// ═══════════════════════════════════════════════════════════════
// Handoff — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button } from '@mantine/core';
import {
  IconLayoutDashboard, IconCalendarEvent, IconArrowsExchange,
  IconChecklist, IconChartBar, IconTemplate, IconUsers,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/handoff', icon: IconLayoutDashboard, exact: true },
  { label: 'Events', path: '/handoff/events', icon: IconCalendarEvent },
  { label: 'Handoffs', path: '/handoff/notes', icon: IconArrowsExchange },
  { label: 'Staff Roster', path: '/handoff/staff', icon: IconUsers },
  { label: 'Actions', path: '/handoff/actions', icon: IconChecklist },
  { label: 'Analytics', path: '/handoff/analytics', icon: IconChartBar, minLevel: 'editor' },
  { label: 'Templates', path: '/handoff/templates', icon: IconTemplate, minLevel: 'editor' },
];

export default function HandoffLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('handoff', NAV_ITEMS);

  const isDetail = pathname.match(/\/handoff\/event\/\d/) || pathname.match(/\/handoff\/note\//);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
        <Breadcrumbs
          items={[
            { label: 'Hub', to: '/' },
            { label: 'Handoff', to: '/handoff' },
            ...(currentPage && currentPage.path !== '/handoff' ? [{ label: currentPage.label }] : []),
          ]}
        />
        <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
          {visibleItems.map(item => {
            const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
            return (
              <Button
                key={item.path}
                variant={active ? 'filled' : 'light'}
                color={active ? brand.blurple : 'gray'}
                size="xs"
                leftSection={<item.icon size={14} />}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Button>
            );
          })}
        </Group>
        </>
      )}
      <Outlet />
    </div>
  );
}
